// components/Suppliers.js
'use client';

import { Flex, Typography } from 'antd'
import Image from 'next/image'
import { isNull } from '@/lib/utils';
import { useEffect, useState, useMemo } from 'react';


const { Paragraph } = Typography;

export default function Suppliers({ suppllerRecommend }) {

    if (isNull(suppllerRecommend) || suppllerRecommend.length <= 0) {
        return null;
    }

    const [currentIndex, setCurrentIndex] = useState(0);
    const itemWidth = '33'; // 每个项占的px

    const data = suppllerRecommend;

    // 处理分页数据切片
    const visibleData = useMemo(() => {
        const end = currentIndex + 3;
        return data.slice(currentIndex, end);
    }, [currentIndex, data]);

    // 计算位移
    const translateX = useMemo(() => {
        if (data.length <= 3) return 0;
        const maxIndex = Math.max(data.length - 3, 0);
        return -Math.min(currentIndex, maxIndex) * itemWidth;
    }, [currentIndex, data.length, itemWidth]);

    const canGoNext = currentIndex + 3 < data.length;
    const canGoPrev = currentIndex > 0;

    const handleNext = () => {
        if (canGoNext) {
            setCurrentIndex(prev => Math.min(prev + 3, data.length - 3));
        }
    };

    const handlePrev = () => {
        if (canGoPrev) {
            setCurrentIndex(prev => Math.max(prev - 3, 0));
        }
    };


    const handleSupplierClick = (item) => {
        window.open(`/shop/${item.id}`)
    }

    return (
        <div className='selected_suppliers'>
            <div className='box_warp '>
                <div className='title'>Selected Suppliers</div>
                <div className='viewport'>
                    <div className='suppliers_warp' >
                        {canGoPrev && <Image src="https://public-read-bkt-oss.oss-cn-hangzhou.aliyuncs.com/PC/yiwuTrade/shop/icon_lf_arrow.png" alt='arrow_lf' className='icon_lf_arrow' width={53} height={53} onClick={handlePrev} />}
                        <Flex className='suppliers_bx' align='center' style={{
                            transform: `translateX(${translateX}%)`,
                            transition: 'transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                        }}>
                            {
                                suppllerRecommend.map((item, key) => (
                                    <div className='suppliers_item_bx' key={key} onClick={() => handleSupplierClick(item)}>
                                        <div className='suppliers_item' style={{ marginLeft: key !== 0 ? '16px' : 0 }}>
                                            <Image
                                                src={item.headPicUrl + '?x-oss-process=image/resize,w_200'}
                                                alt={item.name}
                                                width={72}
                                                height={72}
                                                className='store_header_img'
                                            />

                                            <div className='suppliers_store_name'>{item.name}</div>

                                            <Flex className='suppliers_store_desc' align='center' justify='center'>
                                                {item.businessAge && <Flex align='center' justify='center' className='suppliers_store_item'>{item.businessAge} yrs</Flex>}
                                                {item.employeeNum && <Flex align='center' justify='center' className='suppliers_store_item'>{item.employeeNum}+staff</Flex>}
                                                {item.companyArea && <Flex align='center' justify='center' className='suppliers_store_item'>{item.companyArea}+㎡</Flex>}
                                                <div></div>
                                            </Flex>


                                            <Flex align='center' flex={1} justify='space-around'>
                                                {
                                                    item.products.length > 0 && item.products.slice(0, 3).map((product, key) => (
                                                        <div className='suppliers_item_img_bx' key={key}>
                                                            <Image
                                                                src={product.picUrl + '?x-oss-process=image/resize,w_200'}
                                                                fill
                                                                alt={item.name}
                                                                className='suppliers_item_img'
                                                                loading="lazy"
                                                                blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdj+PLly38ACZgD3EOjaxgAAAAASUVORK5CYII=" />
                                                        </div>
                                                    ))
                                                }

                                            </Flex>

                                            <Paragraph ellipsis={{ rows: 2 }} className='store_main'>{item.mainSell}</Paragraph>
                                        </div>
                                    </div>
                                ))
                            }
                        </Flex>
                        {canGoNext && <Image src="https://public-read-bkt-oss.oss-cn-hangzhou.aliyuncs.com/PC/yiwuTrade/shop/icon_rt_arrow.png" alt='arrow_rt' className='icon_rt_arrow' width={53} height={53} onClick={handleNext} />}
                    </div>
                </div>
            </div>
        </div>

    );
}